import {
  OBSTETRIC_IMPRESSION,
  OBSTETRIC_INDICATIONS,
  obstetricFindings,
} from "../groups/obstetric";
import type { UsWorksheetDefinition } from "../us-fields";

export const US_OB_TRANSABDOMINAL: UsWorksheetDefinition = {
  examType: "us_ob_transabdominal",
  version: 1,
  indications: OBSTETRIC_INDICATIONS,
  otherIndication: true,
  sections: [
    {
      id: "obstetric_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: obstetricFindings("Fetal Heart Rate"),
    },
    {
      id: "obstetric_impression",
      label: "Impression",
      role: "impression",
      fields: [OBSTETRIC_IMPRESSION],
    },
  ],
  normalImpressions: [{ sectionId: "obstetric_impression", value: "live_iup" }],
  billing: {
    codes: [
      {
        cpt: "76815",
        label: "Ultrasound Pregnant Uterus, Limited",
        preTick: true,
      },
    ],
  },
};
